import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { RouletteHistory } from '@/components/roulette/RouletteHistory'
import { Button } from '@/components/ui'
import { useRoulette } from '@/hooks/roulette/useRoulettes'

export function RouletteProgressPage() {
  const { t } = useTranslation()
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const { data: rouletteDetails } = useRoulette(id)

  const handleBackToList = () => {
    navigate('/dashboard/roulette')
  }

  const handleSpinRoulette = () => {
    if (id) {
      navigate(`/dashboard/roulette/${id}/spin`)
    }
  }

  if (!id) {
    navigate('/dashboard/roulette')
    return null
  }

  if (!rouletteDetails) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <p className="text-muted-foreground">{t('common.loading')}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-background">
      <RouletteHistory
        rouletteId={id}
        onBackToRoulette={handleBackToList}
        onSpinRoulette={handleSpinRoulette}
      />

      {/* Fixed Floating Action Buttons */}
      <div className="fixed bottom-6 right-6 flex flex-col gap-3">
        <Button
          onClick={handleSpinRoulette}
          className="w-14 h-14 rounded-full bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg animate-pulse"
          title={t('roulette.spinRoulette')}
        >
          🎰
        </Button>
      </div>
    </div>
  )
}
